// extracted by mini-css-extract-plugin
export var copyIcon = "_ya-2";
export var discountCard = "_ya-0";
export var discountCode = "_ya-3";
export var discountContent = "_ya-1";
export var loadingCard = "_ya-4";